module.exports = __webpack_public_path__ + "static/img/par_bg.c855de0.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flow/par_bg.gif
// module id = ojd5
// module chunks = 0